import apiClient from "./apiClient";

const getMyProfile = async () => {
    const token = localStorage.getItem("authToken");
    const response = await apiClient.get("/users/me", {
        headers: { Authorization: token },
    });
    return response.data;
};

const updateMyProfile = async (payload) => {
    const token = localStorage.getItem("authToken");
    const response = await apiClient.put("/users/me", payload, {
        headers: { Authorization: token },
    });
    return response.data;
};

const userService = {
    getMyProfile,
    updateMyProfile,
};

export default userService;
